import React, { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

function RequireGroup({ group, children }) {
  const { user } = useContext(AuthContext);
  const userGroups = user?.groups || [];

  // Se o usuário pertencer a pelo menos um dos grupos especificados
  const hasAccess = group.some((grp) => userGroups.includes(grp));

  return hasAccess ? children : null;
}

export default RequireGroup;